import { render, staticRenderFns } from "./TableFooter.vue?vue&type=template&id=ed5bce7e&"
import script from "./TableFooter.vue?vue&type=script&setup=true&lang=js&"
export * from "./TableFooter.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed5bce7e')) {
      api.createRecord('ed5bce7e', component.options)
    } else {
      api.reload('ed5bce7e', component.options)
    }
    module.hot.accept("./TableFooter.vue?vue&type=template&id=ed5bce7e&", function () {
      api.rerender('ed5bce7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/TableFooter.vue"
export default component.exports